
import { FC } from "react";
import { Box, Card, CardProps, Flex, Link, Text, Typography, Img, useModal } from "@xcorejs/ui";
import ContactDetailModal from "components/ContactDetailModal";
import { useLayout } from "xcore";
import { Person } from "xcore/types";

export type PersonCardProps = {
  person: Person;
} & CardProps;

const PersonCard: FC<PersonCardProps> = ({ person, ...props }) => {
  const { values: p } = person;
  const { header: { nav }, stringify, file, title } = useLayout();
  const [showDetails] = useModal(ContactDetailModal, { person });

  const imgSrc = file(p.photo, { width: 190, height: 240 });
  const bigImgSrc = file(p.photo, { width: 190, height: 240, enlargement: 2 });
  const name = title(person);

  return (
    <Card
      variant="elevated"
      media={(
        imgSrc && (
          <Link
            v="simple"
            maxWidth="100%"
            onClick={() => showDetails({})}
          >
            <Img
              src={imgSrc}
              srcSet={`${imgSrc} 1x${bigImgSrc ? `, ${bigImgSrc} 2x` : ""}`}
              alt={name}
              width="100%"
              maxWidth="19rem"
              loading="lazy"
            />
          </Link>
        )
      )}
      _media={{ alignItems: "flex-start", flex: "0 0 auto" }}
      body={(
        <Flex flexDirection="column" width="100%" height="100%" justifyContent="space-between">
          <Box>
            <Text variant="strong" color="#1E1E1E">
              {name}
            </Text>
            <Typography variant="p" overflow="hidden" display="-webkit-box" WebkitLineClamp={3} WebkitBoxOrient="vertical">
              <span title={stringify(p.jobTitle)}>{stringify(p.jobTitle)}</span>
            </Typography>
          </Box>

          <Typography>
            <Link
              v="underline"
              maxWidth="100%"
              onClick={() => showDetails({})}
            >
              {stringify(nav.offices.values.personShowMore) ? stringify(nav.offices.values.personShowMore) : "Show detail"}
            </Link>
          </Typography>
        </Flex>
      )}
      _body={{
        padding: 0,
        paddingTop: imgSrc ? "2.2rem" : 0,
        height: "100%"
      }}
      boxShadow="none"
      height="100%"
      justifyContent="space-between"
      {...props}
    />
  );
};

export default PersonCard;
